import { useMutation } from '@tanstack/react-query';
import { useAccessToken } from '../useProfile';

type SharePlannedWorkoutVariables = {
  workoutId: number;
};

type SharePlannedWorkoutResult = {
  url: string;
  token: string;
};

export const useSharePlannedWorkout = () => {
  const { data: accessToken } = useAccessToken();

  return useMutation({
    mutationFn: async ({
      workoutId,
    }: SharePlannedWorkoutVariables): Promise<SharePlannedWorkoutResult> => {
      const response = await fetch(
        `${import.meta.env.REACT_APP_API_SERVICE_URI}/api/profile/plan/workouts/${workoutId}/share`,
        {
          method: 'POST',
          headers: { Authorization: `Bearer ${accessToken || ''}` },
        },
      );

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.error || 'Unable to create share link');
      }

      return response.json();
    },
  });
};
